import React from 'react';
import { Calendar } from 'primereact/calendar';
import { dayjsFromLocalDateString, shortDateFormat, stringYMDFromDayjs } from '@utils/dateWithTz';
import { isNullOrUndefined } from '@utils/utils.tsx';
import { useTranslation } from 'react-i18next';

interface ComponentProps {
  value: string;
  onChange: (localDate: string) => void;
  disabled?: boolean;
  fullWidth?: boolean;
  required?: boolean;
  baseZIndex?: number;
  minDate?: Date;
  maxDate?: Date;
  dataTestId?: string;
}

const RingilCalendar: React.FC<ComponentProps> = ({ value, onChange, disabled = false, fullWidth = false, baseZIndex, minDate, maxDate, dataTestId }) => {

  const convert = () => {
    if (isNullOrUndefined(value)) return null;
    return dayjsFromLocalDateString(value).toDate();
  };

  const convertToUI = (value: Date | Date[]) => {
    const date = value as Date;
    // PrimeReact fires onChange with a null value when the user types an unparseable/incomplete
    // date into the text input. Treat that as clearing the field (same as the clear button) rather
    // than dereferencing null. (Sentry RINGIL-APP-QV.)
    if (isNullOrUndefined(date)) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;
    return stringYMDFromDayjs(dayjsFromLocalDateString(dateString));
  };

  const style = fullWidth ? { width: '100%' } : {};

  const { i18n } = useTranslation();

  return (
    <div>
      <Calendar
        locale={i18n.language}
        value={convert()}
        showIcon={true}
        dateFormat={shortDateFormat}
        onChange={e => onChange(convertToUI(e.target.value))}
        disabled={disabled}
        style={style}
        showButtonBar={true}
        onClearButtonClick={() => onChange(null)}
        baseZIndex={baseZIndex}
        minDate={minDate}
        maxDate={maxDate}
        data-testid={dataTestId}
      />
    </div>
  );
};

export default RingilCalendar;
